import { unitLabel } from './presentation';
/** Render equipment and facility codes consistently in consultant-facing copy. */
export function friendlyLabel(value?: string | null): string {
  if (!value) return 'Not specified';
  if (unitLabel(value) !== value) return unitLabel(value);
  const text = value.toLowerCase().replace(/_/g, ' ');
  return text.replace(/^./, c => c.toUpperCase()).replace(/\btmv\b/g, 'TMV').replace(/^Tmv\b/, 'TMV');
}
